import {
  AppBar,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import moment from "moment";
import React, { useEffect } from "react";
import { CandidateActivityBarChart } from "./CandidateActivityBarChart";
import { MissionHoverView } from "./CandidateSummaryView/MissionHoverView";
import { CandidateAnalytics } from "./CandidateAnalytics";
import _ from 'lodash';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export const CandidateEngagement = ({
    candidate,
    missions,
    getCandidateEngagements,
    portaldetails,
}) => {
    let [showResources, setShowResources] = React.useState(false);
    let [showCourses, setShowCourses] = React.useState(false);
    let [showMissions, setShowMissions] = React.useState(false);
    let [showChallenges, setShowChallenges] = React.useState(false);
    let [showEngagement, setShowEngagement] = React.useState(true);
    let [showJobs, setShowJobs] = React.useState(true);
    
    let d = new Date();
    let [chartYear, setChartYear]   = React.useState(d.getFullYear());
    let [chartMonth, setChartMonth] = React.useState(d.getMonth());


    useEffect(() => {
      async function fetchEngagements() {
        try {
          await getCandidateEngagements();
        } catch (error) {}
      }
      fetchEngagements();
    }, []);

    if (!candidate.assessmentCompleted) {
      return (
        <Grid>
          <Grid container item size="grow" justify="center">
            <Typography variant="subtitle2">
              This candidate has not completed the assessment yet.
            </Typography>
          </Grid>
        </Grid>
      );
    }
    const appEngagements = candidate.engagements;


    const { jobsApplied, jobsSaved, jobsViewed, qualsViewed, qualsSaved, qualsApplied, resourceViewed = [], coursesViewed = [] } = candidate;

    const type3Interventions = portaldetails.interventions.filter(
      ({ type }) => type === 3
    );

    let orgcontracts = portaldetails.orgcontracts;
    let hideQualifications = true;

    _.each(orgcontracts,(contract) => {
      if (contract.jobsType > 0) {
        hideQualifications = false;
      }
    });

    let dates = [];
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const getDaysInMonth = function(month,year) {
      return new Date(year, month, 0).getDate();
    };

    
    if (appEngagements && appEngagements.chartData)  {
      let days = getDaysInMonth(chartYear, chartMonth); 

      for (var i = 1; i !== days + 1; i++) {
        let d = new Date(chartYear, chartMonth , i ).toISOString();
        let m = new Date(chartYear, chartMonth , i ).getMonth();
        if (m !== chartMonth) continue;
        let findD = _.find(appEngagements.chartData, (data) => {
          return data.date === d;
        });
        let duration = (findD && findD.duration) ? findD.duration : 0;
        dates.push({date: d, duration: duration})
      }
    }
    

    const goBackMonth = () => {
      chartMonth = chartMonth - 1;
      if (chartMonth === -1) {
        chartMonth = 11;
        chartYear = chartYear - 1; 
        setChartMonth(chartMonth);
        setChartYear(chartYear);
      } else {
        setChartMonth(chartMonth); 
      }
    }

    const goForwardMonth = () => {
      chartMonth = chartMonth + 1;
      if (chartMonth === 12) {
        chartMonth = 1;
        chartYear = chartYear + 1; 
        setChartMonth(chartMonth);
        setChartYear(chartYear);
      } else {
        setChartMonth(chartMonth); 
      }
    }
    
    const getMonthYear = () => {
      return monthNames[chartMonth] + " " + chartYear;
    }

    const showQualifications = () => {

      if (!hideQualifications){
      return <><Grid item>
        <AppBar
          position="static"
          color="default"
          elevation={0}
          sx={{ mt: 5, mb: 2.5 }}
        >
          <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
            <Typography variant="h6" color="inherit">
              Qualifications and Training
            </Typography>
          </Toolbar>
        </AppBar>
      </Grid>
      <Grid item style={{ marginTop: 10 }}>
        {qualsViewed && (
          <CandidateAnalytics
            jobsViewed={qualsViewed}
            jobsApplied={qualsApplied}
            jobsSaved={qualsSaved}
            isQual={true}
          />
        )}
      </Grid></>
      } else {
        return <></>
      }
    }


    return (
      <>
        {/*

 <Grid item>
          <AppBar
            position="static"
            color="default"
            elevation={0}
            className={classes.sectionTitle}
          >
            <Toolbar variant="dense" className={classes.center}>
              <Typography variant="h6" color="inherit">
                Rewards
              </Typography>
            </Toolbar>
          </AppBar>
        </Grid>
        */}

        <Grid item>
          <AppBar
            position="static"
            color="default"
            elevation={0}
            sx={{ mt: 5, mb: 2.5 }}
          >
            <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
              <Typography variant="h6" color="inherit" onClick={() => {
                if (showJobs){
                  setShowJobs(false);
                } else {
                  setShowJobs(true);
                }
              }} sx={{ cursor: 'pointer' }}>{"Jobs & Occupations"}
              {showJobs ? 
                (
                  <ExpandMoreIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                ):
                ( 
                  <ExpandLessIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                )}
              </Typography>
            </Toolbar>
          </AppBar>
        </Grid>
        <div style={{display: (showJobs) ? "block" : "none"}}>
        <Grid item style={{ marginTop: 10 }}>
          {jobsViewed && (
            <CandidateAnalytics
              jobsViewed={jobsViewed}
              jobsApplied={jobsApplied}
              jobsSaved={jobsSaved}
            />
          )}
        </Grid>
        {showQualifications()}
        </div>

        {appEngagements ? (
          <>
            <Grid item>
              {appEngagements.chartData.length > 0 ? (
                <>
                  <Grid item>
                    <AppBar
                      position="static"
                      color="default"
                      elevation={0}
                      sx={{ mt: 5, mb: 2.5 }}
                    >
                      <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
                        <Typography variant="h6" color="inherit" onClick={() => {
                          if (showEngagement){
                            setShowEngagement(false);
                          } else {
                            setShowEngagement(true);
                          }
                        }} sx={{ cursor: 'pointer' }}>
                          Engagement
                          {showEngagement ? 
                          (
                            <ExpandMoreIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                          ):
                          ( 
                            <ExpandLessIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                          )}
                        </Typography>
                      </Toolbar>
                    </AppBar>
                  </Grid>
                  <div style={{display: (showEngagement) ? "block" : "none"}}>
                  <Grid item >
                    <AppBar position="static" color="default" elevation={0}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        style={{ padding: "1em" }}
                        spacing={2}
                      >
                        {/* <Grid item size>
                    <p>First Session</p>
                    <p>First Session</p>
                  </Grid> */}
                        <Grid item>
                          <Typography>Last Login Activity</Typography>
                          <Typography>
                            <strong>
                              {" "}
                              {moment(candidate.lastAuthenticatedAt).format(
                                "DD/MM/YYYY hh:mm:ss a"
                              )}
                            </strong>
                          </Typography>
                        </Grid>

                        <Grid item>
                          <Typography>No. of Sessions</Typography>
                          <Typography>
                            <strong>{appEngagements.numberOfSessions}</strong>
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography>Overall Duration</Typography>
                          <Typography>
                            <strong>
                              {appEngagements.totalDurationFormatted}
                            </strong>
                          </Typography>
                        </Grid>
                      </Grid>
                    </AppBar>
                  </Grid>
                  <Grid container justifyContent="center" style={{marginTop:10, width:"100%"}}>
                  <Grid item>
                    <Button variant="contained" onClick={goBackMonth}>Previous Month</Button>
                  </Grid>
                  <Grid item style={{marginTop: 6,paddingLeft: 20,paddingRight: 20}}>
                    <Typography> {getMonthYear()} </Typography>
                  </Grid>
                  <Grid item  > 
                    <Button variant="contained" onClick={goForwardMonth}>Next Month</Button>
                  </Grid>
                  </Grid>
                  <Grid item style={{ marginTop: 10 }}>
                    <CandidateActivityBarChart
                      data={dates}
                      valueKey="duration"
                    />
                  </Grid>
                  </div>
                </>
              ) : null}
            </Grid>
          </>
        ) : null}
        {missions ? (
          <>
            <Grid item>
              <AppBar
                position="static"
                color="default"
                elevation={0}
                sx={{ mt: 5, mb: 2.5 }}
              >
                <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
                  <Typography variant="h6" color="inherit" onClick={() => {
                    if (showChallenges){
                      setShowChallenges(false);
                    } else {
                      setShowChallenges(true)
                    }
                  }} sx={{ cursor: 'pointer' }}>
                    Challenges
                    {showChallenges ? 
                    (
                      <ExpandMoreIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    ):
                    ( 
                      <ExpandLessIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    )}
                  </Typography>
                </Toolbar>
              </AppBar>
            </Grid>
            <Grid item style={{display: (showChallenges) ? "block" : "none"}}>
              <Table sx={{ width: "100%" }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Status</TableCell>
                    {/*<TableCell>Push</TableCell>*/}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {type3Interventions.map((row) => {
                    let status = "Not Started";

                    const candidateIntervention = candidate.interventions
                      ? candidate.interventions[row.sort]
                      : null;

                    if (candidateIntervention) {
                      status = "Started";
                    }
                    if (
                      candidateIntervention &&
                      candidateIntervention.status === "Complete"
                    ) {
                      status = "Complete";
                    }

                    return (
                      <TableRow key={row.sort}>
                        <TableCell sx={{ width: "15em" }}>
                          {row.title}
                        </TableCell>
                        <TableCell sx={{ width: "15em" }}>
                          {status}
                        </TableCell>

                      { /* <TableCell className={classes.tableCell}>
                          <Button
                            variant="outlined"
                            color="primary"
                            className={classes.button}
                            endIcon={<ArrowForwardIcon />}
                          >
                            Send
                          </Button>
                        </TableCell>*/
                  }
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
            <Grid item>
              <AppBar
                position="static"
                color="default"
                elevation={0}
                sx={{ mt: 5, mb: 2.5 }}
              >
                <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
                  <Typography variant="h6" color="inherit" onClick={() => {
                    if (showMissions){
                      setShowMissions(false);
                    } else {
                      setShowMissions(true)
                    }
                  }} sx={{ cursor: 'pointer' }}>
                    Missions
                    {showMissions ? 
                    (
                      <ExpandMoreIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    ):
                    ( 
                      <ExpandLessIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    )}
                  </Typography>
                </Toolbar>
              </AppBar>
            </Grid>
            <Grid item style={{ marginTop: "2em", display: (showMissions) ? "block" : "none"}}>
              <Table sx={{ width: "100%" }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Dimension</TableCell>
                    <TableCell>Score</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {missions.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ width: "15em" }}>
                        <MissionHoverView {...row} />
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        {row.status}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        {row.dimensionText}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        {row.score}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
            <Grid item>
              <AppBar
                position="static"
                color="default"
                elevation={0}
                sx={{ mt: 5, mb: 2.5 }}
              >
                <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
                  <Typography variant="h6" color="inherit" onClick={() => {
                    if (showResources){
                      setShowResources(false);
                    } else {
                      setShowResources(true)
                    }
                  }} sx={{ cursor: 'pointer' }}>
                    Resources
                    {showResources ? 
                    (
                      <ExpandMoreIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    ):
                    ( 
                      <ExpandLessIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    )}
                  </Typography>
                </Toolbar>
              </AppBar>
            </Grid>
            <Grid item style={{ marginTop: "2em", display: (showResources) ? "block" : "none"}}>
              {resourceViewed.length === 0 &&
                <h4 style={{textAlign:"center"}}> No resources has been viewed </h4>
              }
              {resourceViewed.length > 0 &&
              <Table sx={{ width: "100%" }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Link</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {resourceViewed.map((row) => (
                    <TableRow key={row.sort}>
                      <TableCell sx={{ width: "15em" }}>
                        {row.title}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        <a href={row.link} target="_blank" rel="noopener noreferrer">View here</a>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              }
            </Grid>
            <Grid item>
              <AppBar
                position="static"
                color="default"
                elevation={0}
                sx={{ mt: 5, mb: 2.5 }}
              >
                <Toolbar variant="dense" sx={{ textAlign: "center", display: "block", pt: 1.75, border: "1px solid #ddd" }}>
                  <Typography variant="h6" color="inherit" onClick={() => {
                    if (showCourses){
                      setShowCourses(false);
                    } else {
                      setShowCourses(true)
                    }
                  }} sx={{ cursor: 'pointer' }}>
                    Courses
                    {showCourses ? 
                    (
                      <ExpandMoreIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    ):
                    ( 
                      <ExpandLessIcon sx={{ position: "absolute", top: 18, right: 35 }} />
                    )}
                  </Typography>
                </Toolbar>
              </AppBar>
            </Grid>
            <Grid item style={{ marginTop: "2em", display: (showCourses) ? "block" : "none", paddingBottom:"50px"}}>
              {coursesViewed.length === 0 &&
                <h4 style={{textAlign:"center"}}> No courses has been viewed </h4>
              }
              {coursesViewed.length > 0 &&
              <Table sx={{ width: "100%" }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Occupation</TableCell>
                    <TableCell>Viewed On</TableCell>
                    <TableCell>Provider</TableCell>
                    <TableCell>Link</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {coursesViewed.map((row) => (
                    <TableRow key={row.sort}>
                      <TableCell sx={{ width: "15em" }}>
                        {row.name}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        {row.occupation}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        {moment(row.createdAt).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        {row.provider}
                      </TableCell>
                      <TableCell sx={{ width: "15em" }}>
                        <a href={row.url} target="_blank" rel="noopener noreferrer">View here</a>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              }
            </Grid>
            



          </>
        ) : null}
      </>
    );
};
